var _defs, _path, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#f2f2f2;}.c{fill:#e6e6e6;}.d{fill:#ccc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mainBg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.48,0c101.15,160.7,280.11,267.5,484,267.5S942.37,160.7,1043.52,0Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "740.72 65.99 736.56 86.28 754.46 81.49 740.72 65.99"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "696.8 101.92 693.28 107.04 698.79 107.81 696.8 101.92"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "652.92 103.57 647.62 119.43 662.43 117.33 652.92 103.57"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "654.81 29.98 633.03 41.96 651.33 54.6 654.81 29.98"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "596.64 74.66 589.21 80.75 597.06 84.26 596.64 74.66"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "547.83 34.87 542 53.23 559.02 50.55 547.83 34.87"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "381.34 86.55 375.04 104.42 391.85 102.32 381.34 86.55"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "336.82 77.62 330.51 82.61 337.03 85.67 336.82 77.62"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "308.47 75.23 305.31 98.29 325.03 91.59 308.47 75.23"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "283.3 82.05 281.11 92.53 290.37 90.09 283.3 82.05"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "249.75 93.42 234.84 102.37 247.96 110.72 249.75 93.42"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "238.1 60.91 234.81 65.55 239.84 66.33 238.1 60.91"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "236.09 9.95 218.73 21.14 234.63 30.55 236.09 9.95"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "156.76 28.21 150.79 33.76 157.62 36.31 156.76 28.21"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "111.5 38.94 100.98 56.61 119.32 57.96 111.5 38.94"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "550.78 22.21 557.74 35.97 565.96 24.91 550.78 22.21"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "543.76 67.51 552.67 76.31 556.15 65.66 543.76 67.51"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "519.58 61.99 517.59 77.11 530.48 72.65 519.58 61.99"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "485.76 59.46 474.2 84.7 499.01 83.84 485.76 59.46"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "448.89 46.52 449.37 62.35 461.84 55.63 448.89 46.52"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "448.92 108.28 455.55 120.02 462.28 110.02 448.92 108.28"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "401.51 86.66 417.01 103.58 424.35 84.41 401.51 86.66"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "347.16 173.15 372.08 182.34 369.47 158.72 347.16 173.15"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "943.6 82.11 961.52 68.2 943.22 59.43 943.6 82.11"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "999.13 156.82 997.21 130.55 976.96 142.6 999.13 156.82"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1009.2 105.08 1010.03 95.98 1002.42 98.96 1009.2 105.08"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1018.36 144.77 1033.86 137.91 1022.17 128.25 1018.36 144.77"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1008.07 148.53 1033.75 138.31 1015.31 121.85 1008.07 148.53"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1056.22 140.03 1064.65 139.44 1060.81 132.93 1056.22 140.03"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1087.53 198.48 1104.45 179.43 1082.45 173.52 1087.53 198.48"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "912.58 155.06 906.45 161.45 914.01 163.79 912.58 155.06"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "886.36 155.07 878.8 160.96 886.54 164.65 886.36 155.07"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "844.94 135.46 828.5 144.95 842.67 154.3 844.94 135.46"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "838.1 84.46 822.89 87.55 831.45 98.48 838.1 84.46"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "815.32 67.53 811.47 74.75 818.79 74.94 815.32 67.53"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "778.7 55.19 766.65 68.45 782.08 72.78 778.7 55.19"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "744.33 32.13 737.97 41.23 747.79 42.67 744.33 32.13"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "707.23 79.08 704.23 90.24 714.36 88.18 707.23 79.08"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1063.01 70.53 1074.07 89.42 1084.75 73.02 1063.01 70.53"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1057.44 83.62 1052.29 102.3 1069.3 98.95 1057.44 83.62"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "1017.72 104.23 1015.12 109.3 1020.22 109.36 1017.72 104.23"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "975.21 64.47 971.18 70.32 977.47 71.21 975.21 64.47"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "950.53 86.45 940.92 93.8 950.64 98.55 950.53 86.45"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "904.16 100.21 896.95 120.16 915.79 117.95 904.16 100.21"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "926.99 79.79 905.59 96.67 927.65 107.04 926.99 79.79"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "870.35 113.69 864.83 120.03 872.1 121.91 870.35 113.69"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "846.46 97.31 842.99 107.37 852.42 106.12 846.46 97.31"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "821.73 101.7 818.83 114.89 830.54 111.93 821.73 101.7"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "778.62 125.28 781.15 139.07 791.17 131.53 778.62 125.28"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "738.42 134.95 729.18 154.57 748.57 154.11 738.42 134.95"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "708.72 98.48 704.73 106.51 712.75 106.49 708.72 98.48"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "682.85 155.15 689.44 172.09 700.36 160.04 682.85 155.15"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "563.48 260.95 556.88 259.33 558.23 265.26 563.48 260.95"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "582.04 212.24 566.59 207.16 568.7 221.55 582.04 212.24"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "547.8 190.53 529.99 186.79 534.12 202.53 547.8 190.53"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "292.3 159.94 284.75 170.92 296.56 172.56 292.3 159.94"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "280 170.61 271.65 180.5 282.9 183.22 280 170.61"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "266.48 150.1 249.03 164.96 267.9 172.97 266.48 150.1"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "269.88 105.22 264.71 109.13 269.91 111.71 269.88 105.22"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "246.79 77.01 229.77 93.44 249.73 100.48 246.79 77.01"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "188.87 114.46 184.27 120.54 190.98 121.79 188.87 114.46"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "153.64 80.58 141.66 101.22 162.96 102.55 153.64 80.58"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "103.52 47.06 103.53 58.25 112.47 53.77 103.52 47.06"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "590.48 39.09 590.32 53.39 601.83 47.79 590.48 39.09"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "566.64 51.13 565.49 76.58 586.31 67.31 566.64 51.13"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "583.26 106.83 585 119.28 594.26 112.91 583.26 106.83"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "552.1 122.65 554.02 138.61 566.03 130.69 552.1 122.65"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "523.48 111.32 517.53 118.65 525.77 120.48 523.48 111.32"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "473.49 118.27 472.45 140.92 490.98 132.69 473.49 118.27"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "437.56 99.7 427.17 115.5 443.96 117.49 437.56 99.7"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "396.69 145.72 397.54 159.72 408.4 153.44 396.69 145.72"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "154.18 70.33 142.53 84.39 158.43 88.09 154.18 70.33"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "117.64 62.3 104.61 80.74 124.57 83.78 117.64 62.3"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "89.36 75.89 87.23 83.75 94.37 82.31 89.36 75.89"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "41.04 71.17 31.17 80.89 42.89 84.9 41.04 71.17"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "1002.78 42.86 1004.34 60.93 1018.17 52.46 1002.78 42.86"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "983.09 95.25 971.08 114.9 991.6 116.65 983.09 95.25"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "953.4 93.26 953.86 107.16 964.79 101.23 953.4 93.26"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "935.46 52.75 934.15 64.62 944.17 60.92 935.46 52.75"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "907.24 93.88 888.69 110.08 909.07 118.43 907.24 93.88"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "672.38 65.49 666.05 78.14 678.71 78.15 672.38 65.49"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "660.6 87.83 650.28 99.52 663.76 103.1 660.6 87.83"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "640.38 76.07 638.44 87.81 648.61 84.67 640.38 76.07"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "605.86 79.33 602.27 90.38 612.54 88.83 605.86 79.33"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "561.31 77.64 553.66 96.01 571.41 94.78 561.31 77.64"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "529.1 84.53 522.44 91.89 530.99 94.28 529.1 84.53"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "501.66 96.72 497.38 103.15 504.24 104 501.66 96.72"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "453.04 51.25 450.08 57.74 456.46 57.52 453.04 51.25"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "413.01 58.73 410.64 66.15 417.52 65.08 413.01 58.73"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "382.86 57.72 377.59 64.95 385.48 66.28 382.86 57.72"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "404.89 95.92 400.43 105.27 409.7 105.09 404.89 95.92"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "382.58 77.59 375.85 83.82 383.53 86.71 382.58 77.59"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "373.64 60.09 355.63 70.07 370.82 80.48 373.64 60.09"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "334.34 31.78 317.49 38.02 329.22 49 334.34 31.78"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "247.25 44.69 242.33 54.77 252.36 54.67 247.25 44.69"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "229.26 48.6 223.94 59.17 234.53 59.19 229.26 48.6"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "822.41 85.66 812.16 104.67 831.47 105.27 822.41 85.66"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "762.32 51.3 763.23 57.74 768.02 54.44 762.32 51.3"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "751.53 97.96 753.16 110 762.14 103.88 751.53 97.96"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "724.91 72.43 717.23 88.43 733.1 88.18 724.91 72.43"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "691.14 88.35 687.28 93.42 692.88 94.48 691.14 88.35"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "648.66 70.54 643.31 80.45 653.38 80.77 648.66 70.54"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "722.41 97.81 719.06 102.55 724.2 103.33 722.41 97.81"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "695.8 133.72 691.12 143.65 700.94 143.42 695.8 133.72"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "667.88 100.79 653.93 113.32 669.53 119.46 667.88 100.79"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "642.06 107.37 642.48 120.56 652.87 114.94 642.06 107.37"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "583.1 80.99 573.26 98.17 590.93 99.17 583.1 80.99"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "564.67 95.27 559.85 102.49 567.56 103.46 564.67 95.27"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "545.72 150.97 546.48 161.51 554.61 156.69 545.72 150.97"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "531.94 166.51 526.55 178.82 538.56 178.21 531.94 166.51"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "515.84 155.87 509.11 161.62 516.39 164.7 515.84 155.87"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "507.4 123.53 483.42 133.34 500.86 148.6 507.4 123.53"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "489.1 105.13 478.36 108.01 484.96 115.44 489.1 105.13"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "439.43 121.04 427.81 127.51 437.63 134.22 439.43 121.04"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "399.16 61.54 389.41 83.23 410.66 82.34 399.16 61.54"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "344.06 101.02 336.45 126.09 359.55 122.15 344.06 101.02"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "819.05 116.46 811.02 137.42 831 135.46 819.05 116.46"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "774.28 106.68 767.91 124 784.32 122.17 774.28 106.68"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "738.26 115.6 732.97 142.54 756.63 135.99 738.26 115.6"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "706.56 137.81 692.45 161.76 717.26 163.47 706.56 137.81"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainBg);
export default __webpack_public_path__ + "static/media/mainBg.9d8d65e091a36300ef88f449d5c87aff.svg";
export { ForwardRef as ReactComponent };